import React, { Component } from "react";
import Big from "big.js";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import { debounce } from "util";
import Typography from "material-ui-next/Typography";
import {
  Page,
  DataTable,
  StyledButton,
  IconButton,
  CurrencyField,
  Loadable
} from "components/support";
import Filter from "../filter";
import StockCount from "./import-stock-count";

class InventoryAdjustView extends Component {
  config = {
    identifier: "uuid",
    columns: [
      {
        accessor: "uuid",
        show: false
      },
      {
        accessor: "category_uuid",
        show: false
      },
      {
        id: "code",
        accessor: "code",
        Header: "Código",
        width: 180
      },
      {
        id: "name",
        accessor: "name",
        Header: "Nome"
      },
      {
        id: "stock_count",
        accessor: "stock_count",
        Header: "Total Estoque",
        align: "right",
        width: 150
      },
      {
        id: "counting",
        accessor: "counting",
        Header: "Contagem",
        align: "center",
        sortable: false,
        width: 150,
        Cell: props => this.countingField(props.row._original)
      },
      {
        id: "diff",
        accessor: "diff",
        Header: "Diferença",
        align: "center",
        sortable: false,
        width: 150,
        Cell: props => this.difference(props.row._original)
      }
    ]
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.filter !== this.props.filter) {
      nextProps.presenter.onFilterChange(nextProps.filter);
    }
  }

  difference = product => {
    const counting = this.props.viewModel.counting[product.uuid];

    if (!counting) {
      return <span>-</span>;
    }

    const diff = Big(counting).minus(product.stock_count);
    const chipStyle = {
      marginLeft: 10,
      padding: "2px 6px",
      borderRadius: 4,
      background: diff.lt(0) ? "#D00" : "#DDD",
      color: diff.lt(0) ? "#FFF" : "#333",
      fontWeight: "bolder"
    };

    return <span style={chipStyle}>{diff.toFixed(2)}</span>;
  };

  countingField = product => (
    <div>
      <CurrencyField
        fullWidth
        unit=""
        noMargin
        value={this.props.viewModel.counting[product.uuid]}
        onChange={(_, value) =>
          this.props.presenter.handleCountingChange(product.uuid, value)
        }
      />
    </div>
  );

  onFileSelect = files => this.props.presenter.onFileSelect(files[0]);

  importStockCount = () => (
    <StockCount
      loading={this.props.viewModel.loading}
      stockCountOpen={this.props.viewModel.stockCountOpen}
      onImportStockCountClose={() =>
        this.props.presenter.onImportStockCountClose()
      }
      downloadCsv={() => this.props.presenter.onDownload()}
      onFileSelect={files => this.props.presenter.onFileSelect(files[0])}
      onImportStockCountConfirmation={() =>
        this.props.presenter.onImportStockCountConfirmation()
      }
      status={this.props.viewModel.upload.status}
    />
  );

  render() {
    const { presenter, viewModel } = this.props;
    const { loading, resultSet, pagination, order } = viewModel;
    return (
      <Page>
        <Row>
          <Col xs={12} sm>
            <Typography type="display1" className="pb-sm">
              <IconButton
                icon="arrow_back"
                onClick={() => presenter.onGoBack()}
              />
              Ajuste de Inventário
            </Typography>
          </Col>

          <Col style={{ marginBottom: 20 }}>
            <StyledButton
              accent
              label="Importar Contagem"
              onTouchTap={() => presenter.onImportStockCount()}
            />
          </Col>
        </Row>
        <Row>
          <Col className="product__content" xs={12}>
            <Filter
              onFilter={debounce(filter => presenter.onFilterChange(filter))}
              loading={loading}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12} xs={12}>
            <div>
              <h3 style={{ textAlign: "right", padding: 10, margin: 0 }}>
                {pagination.total} produtos(s) encontrado(s).
              </h3>
              <Paper elevation={1} className="product__content">
                <Loadable loading={loading}>
                  <DataTable
                    manual
                    resultSet={resultSet}
                    total={pagination.total}
                    perPage={pagination.perPage}
                    page={pagination.currentPage}
                    config={this.config}
                    orderField={order.field}
                    orderDirection={order.direction}
                    onChange={({ field, value }) =>
                      presenter.onOrderChange(field, value)
                    }
                    onPageChange={page => presenter.onPageChange(page + 1)}
                  />
                </Loadable>
              </Paper>

              <div
                className="text-right p-sm"
                style={{
                  textAlign: "right",
                  padding: "10px 0 10px 10px",
                  margin: 0
                }}
              >
                <StyledButton
                  label="Cancelar"
                  onClick={() => presenter.onGoBack()}
                />
                <StyledButton
                  primary
                  label="Salvar Contagem"
                  style={{ marginRight: 0 }}
                  onClick={() => presenter.onStockModify()}
                />
              </div>
            </div>
          </Col>
        </Row>
        {this.importStockCount()}
      </Page>
    );
  }
}

export default InventoryAdjustView;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/adjust/view.jsx